<template>
  <div :class="{'page_content--loading': !reportData}">
    <div class="vx-row justify-end">
      <div class="vx-col">
        <DateRanges
          :start-day="startDay"
          :end-day="endDay"
          @on-change="onDateChange"
        />
      </div>
    </div>
    <div class="vx-row justify-end">
      <div class="vx-col">
        <switch-field
          v-model="innerFiltered"
          class="mt-4 mb-4"
          name="フィルター表示"
          label="フィルター表示"
        />
      </div>
    </div>
    <div
      v-if="showFilters"
      class="vx-row justify-end"
    >
      <div
        style="z-index: 9998;"
        class="vx-col"
      >
        <div class="filter">
          <sales-filter
            v-model="selectedTitles"
            class="w-48 mb-1 mr-1"
            :options="titleOptions"
            :no-option-text="salesByTitleFilterNoOptionText"
            placeholder="商品名"
          />
          <sales-filter
            v-model="selectedAsins"
            class="w-48 mb-1 mr-1"
            :options="asinOptions"
            :no-option-text="salesByAsinFilterNoOptionText"
            placeholder="ASIN"
          />
          <sales-filter
            v-model="selectedParentAsins"
            class="w-48 mb-1 mr-1"
            :options="parentAsinOptions"
            :no-option-text="salesByParentAsinFilterNoOptionText"
            placeholder="親ASIN"
          />
          <sales-filter
            v-model="selectedBrands"
            class="w-48 mb-1 mr-1"
            :options="brandOptions"
            :no-option-text="salesByBrandFilterNoOptionText"
            placeholder="ブランド"
          />
          <sales-filter
            v-model="selectedSubCategoryNames"
            class="w-48 mb-1"
            :options="subCategoryNameOptions"
            :no-option-text="salesBySubCategoryNameFilterNoOptionText"
            placeholder="サブカテゴリー名"
          />
        </div>
      </div>
      <div
        class="vx-col"
        style="z-index: 9997;"
      >
        <div class="filter">
          <sales-filter
            v-model="selectedSellerCategories"
            class="w-48 mb-1 mr-1"
            :options="sellerCategoryOptions"
            :no-option-text="salesBySellerCategoryFilterNoOptionText"
            placeholder="出品者カテゴリー1"
          />
          <sales-filter
            v-model="selectedSellerCategories2"
            class="w-48 mb-1 mr-1"
            :options="sellerCategory2Options"
            :no-option-text="salesBySellerCategory2FilterNoOptionText"
            placeholder="出品者カテゴリー2"
          />
          <sales-filter
            v-model="selectedSellerCategories3"
            class="w-48 mb-1 mr-1"
            :options="sellerCategory3Options"
            :no-option-text="salesBySellerCategory3FilterNoOptionText"
            placeholder="出品者カテゴリー3"
          />
          <sales-filter
            v-model="selectedSellerCategories4"
            class="w-48 mb-1 mr-1"
            :options="sellerCategory4Options"
            :no-option-text="salesBySellerCategory4FilterNoOptionText"
            placeholder="出品者カテゴリー4"
          />
          <sales-filter
            v-model="selectedSellerCategories5"
            class="w-48 mb-1"
            :options="sellerCategory5Options"
            :no-option-text="salesBySellerCategory5FilterNoOptionText"
            placeholder="出品者カテゴリー5"
          />
        </div>
      </div>
    </div>
    <div class="vx-row justify-end mr-auto">
      <vx-card class="w-2/5">
        <div class="flex">
          <span class="text-nowrap mr-3">
            リピート対象月数
          </span>
          <div class="w-full">
            <vue-slider
              v-model="sliderValue"
              :adsorb="true"
              :contained="true"
              :min=1
              :max="MAX_REPEAT_TARGET_MONTHS"
              :interval="1"
              tooltip-placement="bottom"
              @drag-end="onDragEnd"
            />
          </div>
        </div>
      </vx-card>
    </div>

    <div>
      <div class="mt-8">
        <vx-card style="height: 720px">
          <data-table
            :row-data="reportData.firstOrderMonth"
            :column-defs="tableProp.firstOrderMonth.columnDefs"
            :default-col-def="tableProp.firstOrderMonth.defaultColDef"
            :grid-options="tableProp.firstOrderMonth.gridOptions"
            :columnsToFit="true"
            style="height: 640px"
          >
            <template #actions>
              <vs-button
                @click="onClickDownload('firstOrderMonth')"
              >
                CSVエクスポート
              </vs-button>
            </template>
          </data-table>
        </vx-card>
      </div>
    </div>

    <div class="vx-row px-4 mt-8">
      <vx-card>
        <amc-arpu-chart
          :class="{'min-h-full': !reportData}"
          :report="reportData.monthlyOrder"
          label-field="eventMonth"
          :height="400"
          :precision="2"
          :startDay="startDay"
          :endDay="endDay"
        />
      </vx-card>
    </div>
    <div
      v-if="reportData"
      class="mt-8"
    >
      <div>
        <vx-card>
          <div class="font-semibold text-right">
            対象月数 / 売上
          </div>
          <data-table
            :row-data="reportData.cohortAnalysis"
            :column-defs="tableProp.cohortAnalysis.columnDefs"
            :default-col-def="tableProp.cohortAnalysis.defaultColDef"
            :grid-options="tableProp.cohortAnalysis.gridOptions"
            :header-height="40"
            style="height: 620px"
          >
          </data-table>
        </vx-card>
      </div>

      <div class="mt-8">
        <vx-card>
          <data-table
            :row-data="reportData.firstOrderAsin"
            :column-defs="tableProp.firstOrderAsin.columnDefs"
            :default-col-def="tableProp.firstOrderAsin.defaultColDef"
            :grid-options="tableProp.firstOrderAsin.gridOptions"
            pagination
            :reset-current-page-flag="resetCurrentPageFlag"
            @update:reset-current-page-flag="resetCurrentPageFlag = false"
          >
            <template #actions>
              <vs-button
                @click="onClickDownload('firstOrderAsin')"
              >
                CSVエクスポート
              </vs-button>
            </template>
          </data-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import chroma from "chroma-js"
import DataTable from '@/components/table/DataTable'
import DateRanges from '@/components/DateRanges'
import SectionTitle from '@/components/SectionTitle'
import SalesFilter from '@/components/SalesFilter'
import AmcArpuChart from '@/user/components/charts/AmcArpuChart'
import SwitchField from '@/components/fields/SwitchField'
import { debounce } from '@/utils'

export default {
  components: {
    DataTable,
    DateRanges,
    SalesFilter,
    SectionTitle,
    SwitchField,
    AmcArpuChart
  },
  data () {
    return {
      // フィルター
      selectedAsins: [],
      selectedTitles: [],
      selectedBrands: [],
      selectedSubCategoryNames: [],
      selectedParentAsins: [],
      selectedSellerCategories: [],
      selectedSellerCategories2: [],
      selectedSellerCategories3: [],
      selectedSellerCategories4: [],
      selectedSellerCategories5: [],
      filtered: false,
      showFilters: false,
      resetCurrentPageFlag: false,
      // 表のプロパティ
      tableProp: {
        cohortAnalysis: {},  // ヒートマップ描画のためwatchで動的に変更する
        firstOrderMonth: {
          defaultColDef: {
            sortable: false,
            editable: false,
            resizable: true,
            suppressMenu: true
          },
          columnDefs: [
            { headerName: 'NTBオーダー月', field: 'firstOrderMonth' },
            { headerName: 'リピート対象月数', field: 'monthsDifference' },
            { headerName: 'NTBユーザー数', field: 'NtbUsers' },
            { headerName: 'LTV売上', field: 'LtvSales', currency: true },
            { headerName: '購入単価', field: 'unitPurchasePrice', currency: true },
            { headerName: 'ARPU', field: 'arpu', currency: true }
          ],
          gridOptions: {},
        },
        firstOrderAsin: {
          defaultColDef: {
            sortable: false,
            editable: false,
            resizable: true,
            suppressMenu: true
          },
          columnDefs: [
            { headerName: 'NTBオーダーASIN', field: 'firstOrderAsin'},
            { headerName: '商品名', field: 'title' },
            { headerName: '親ASIN', field: 'parentAsin' },
            { headerName: 'ブランド', field: 'brand' },
            { headerName: '出品者カテゴリー1', field: 'sellerCategory' },
            { headerName: '出品者カテゴリー2', field: 'sellerCategory2' },
            { headerName: '出品者カテゴリー3', field: 'sellerCategory3' },
            { headerName: '出品者カテゴリー4', field: 'sellerCategory4' },
            { headerName: '出品者カテゴリー5', field: 'sellerCategory5' },
            { headerName: 'リピート対象月数', field: 'monthsDifference' },
            { headerName: 'NTBユーザー数', field: 'NtbUsers' },
            { headerName: 'LTV売上', field: 'LtvSales', currency: true },
            { headerName: '購入単価', field: 'unitPurchasePrice', currency: true },
            { headerName: 'ARPU', field: 'arpu', currency: true }
          ],
          gridOptions: {},
        },
      },
      // APIのactionとパラメータの対応
      apiParameters: {
        cohortAnalysis: ['start_day', 'end_day', 'repeat_target_months', 'filters'],
        monthlyOrder: ['start_day', 'end_day', 'filters'],
        firstOrderMonth: ['start_day', 'end_day', 'repeat_target_months', 'filters'],
        firstOrderAsin: ['start_day', 'end_day', 'repeat_target_months', 'filters'],
        salesByTitle: ['start_day', 'end_day', 'filters'],
        salesByAsin: ['start_day', 'end_day', 'filters'],
        salesByParentAsin: ['start_day', 'end_day', 'filters'],
        salesByBrand: ['start_day', 'end_day', 'filters'],
        salesBySubCategoryName: ['start_day', 'end_day', 'filters'],
        salesBySellerCategory: ['start_day', 'end_day', 'filters'],
        salesBySellerCategory2: ['start_day', 'end_day', 'filters'],
        salesBySellerCategory3: ['start_day', 'end_day', 'filters'],
        salesBySellerCategory4: ['start_day', 'end_day', 'filters'],
        salesBySellerCategory5: ['start_day', 'end_day', 'filters']
      },
      MAX_REPEAT_TARGET_MONTHS: 12,  // リピート対象月数 が取りうる最大値
      sliderValue: 0,
      // ヒートマップ
      cohortAnalysisMaxSales: -1,
      colorScale: chroma.scale(['#F4FAFE', '#008AE5'])
    }
  },
  computed: {
    ...mapState(['startDay', 'endDay']),
    ...mapState('amcArpu', ['requestingStatus', 'reportData', 'filterOptions']),
    ...mapState('account', ['activeAccount']),
    salesByTitleFilterNoOptionText () {
      return this.requestingStatus.salesByTitle ? 'Loading...' : '候補がありません'
    },
    salesByAsinFilterNoOptionText () {
      return this.requestingStatus.salesByAsin ? 'Loading...' : '候補がありません'
    },
    salesByParentAsinFilterNoOptionText () {
      return this.requestingStatus.salesByParentAsin ? 'Loading...' : '候補がありません'
    },
    salesByBrandFilterNoOptionText () {
      return this.requestingStatus.salesByBrand ? 'Loading...' : '候補がありません'
    },
    salesBySubCategoryNameFilterNoOptionText () {
      return this.requestingStatus.salesBySubCategoryName ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategoryFilterNoOptionText () {
      return this.requestingStatus.salesBySellerCategory ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategory2FilterNoOptionText () {
      return this.requestingStatus.salesBySellerCategory2 ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategory3FilterNoOptionText () {
      return this.requestingStatus.salesBySellerCategory3 ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategory4FilterNoOptionText () {
      return this.requestingStatus.salesBySellerCategory4 ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategory5FilterNoOptionText () {
      return this.requestingStatus.salesBySellerCategory5 ? 'Loading...' : '候補がありません'
    },
    parentAsinOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesByParentAsin.map(item => ({
        text: item.parentAsin,
        value: item.parentAsin,
        sales: item.sales
      }))
    },
    sellerCategoryOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesBySellerCategory.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.sales
      }))
    },
    sellerCategory2Options () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesBySellerCategory2.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.sales
      }))
    },
    sellerCategory3Options () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesBySellerCategory3.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.sales
      }))
    },
    sellerCategory4Options () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesBySellerCategory4.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.sales
      }))
    },
    sellerCategory5Options () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesBySellerCategory5.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.sales
      }))
    },
    brandOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesByBrand.map(item => ({
        text: item.brand,
        value: item.brand,
        sales: item.sales
      }))
    },
    asinOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesByAsin.map(item => ({
        text: item.asin,
        value: item.asin,
        sales: item.sales
      }))
    },
    titleOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesByTitle.map(item => ({
        text: item.title,
        value: item.title,
        sales: item.sales
      }))
    },
    subCategoryNameOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesBySubCategoryName.map(item => ({
        text: item.subcategoryName,
        value: item.subcategoryName,
        sales: item.sales
      }))
    },
    selectedBrandValues () {
      return this.selectedBrands.map(selectedCategoryName => selectedCategoryName.value)
    },
    selectedAsinValues () {
      return this.selectedAsins.map(selectedAsin => selectedAsin.value)
    },
    selectedTitleValues () {
      return this.selectedTitles.map(selectedTitle => selectedTitle.value)
    },
    selectedSubCategoryNameValues () {
      return this.selectedSubCategoryNames.map(selectedSubCategoryName => selectedSubCategoryName.value)
    },
    selectedParentAsinValues () {
      return this.selectedParentAsins.map(selectedParentAsin => selectedParentAsin.value)
    },
    selectedSellerCategoryValues () {
      return this.selectedSellerCategories.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    selectedSellerCategory2Values () {
      return this.selectedSellerCategories2.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    selectedSellerCategory3Values () {
      return this.selectedSellerCategories3.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    selectedSellerCategory4Values () {
      return this.selectedSellerCategories4.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    selectedSellerCategory5Values () {
      return this.selectedSellerCategories5.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    innerFiltered: {
      get () {
        return this.filtered
      },
      set (val) {
        this.filtered = val
        this.showFilters = val
      }
    },
  },
  watch: {
    selectedAsins: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedTitles: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedBrands: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSubCategoryNames: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedParentAsins: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories2: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories3: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories4: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories5: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    activeAccount: {
      handler () {
        this.resetFilters()
      }
    },
    sliderValue: {
      handler () {
        this.generateCohortTableProp()
      }
    },
    cohortAnalysisMaxSales: {
      handler () {
        this.generateCohortTableProp()
      }
    }
  },
  created () {
    this.sliderValue = this.MAX_REPEAT_TARGET_MONTHS
    // 初期期間は11ヶ月前一日~前日
    this.$store.commit('SET_STARTDAY', moment().startOf('month').subtract(11, 'month').format('YYYY-MM-DD'))
    this.$store.commit('SET_ENDDAY',  moment().subtract(1, 'days').format('YYYY-MM-DD'))

    this.getReport()
  },
  methods: {
    ...mapActions('amcArpu', ['fetchReport', 'downloadCSV']),
    resetFilters () {
      this.selectedAsins = []
      this.selectedTitles = []
      this.selectedBrands = []
      this.selectedSubCategoryNames = []
      this.selectedParentAsins = []
      this.selectedSellerCategories = []
      this.selectedSellerCategories2 = []
      this.selectedSellerCategories3 = []
      this.selectedSellerCategories4 = []
      this.selectedSellerCategories5 = []
    },
    generateCohortTableProp () {
      const columnDefs = Array.from({length: this.sliderValue}, (_, i) => { 
      return {
        headerName: i+1,
        field: `monthsDifference${i}`,
        width: 135,
        currency: true,
        cellStyle: params => {
          if (params.value > 0) {
            // カラースケール適用
            return { backgroundColor: this.colorScale(params.value / this.cohortAnalysisMaxSales) };
          } else {
            return { backgroundColor: 'white' }
          }
        }
      }
      })

      this.tableProp.cohortAnalysis = {
        defaultColDef: {
          sortable: false,
          editable: false,
          resizable: false,
          suppressMenu: true
        },
        columnDefs: [
          { headerName: 'NTBオーダー月', field: 'firstOrderMonth', width: 135, pinned: 'left' },
          ...columnDefs,
          { headerName: '総計', field: 'totalSales', width: 145, currency: true, cellStyle: { fontWeight: "bold" }, headerClass: 'font-bold'},
        ],
        gridOptions: {}
      }
    },
    onDateChange (date) {
      this.$store.commit('SET_STARTDAY', moment(date.start).format())
      this.$store.commit('SET_ENDDAY',  moment(date.end).format())
      this.getReport()
    },
    onDragEnd () {
      this.getReport()
    },
    generateParams (paramKeys) {
      const params = {}
      if ( paramKeys.includes('start_day') && paramKeys.includes('end_day') ) {
        params['start_day'] = this.startDay.split('T')[0]
        params['end_day'] = this.endDay.split('T')[0]
      }
      if (paramKeys.includes('repeat_target_months')) {
        params['repeat_target_months'] = this.sliderValue
      }
      if ( paramKeys.includes('filters') ) {
        if (this.selectedAsinValues) {
          params['asin'] = this.selectedAsinValues
        }
        if (this.selectedTitleValues) {
          params['title'] = this.selectedTitleValues
        }
        if (this.selectedBrandValues) {
          params['brand'] = this.selectedBrandValues
        }
        if (this.selectedSubCategoryNameValues) {
          params['subcategory_name'] = this.selectedSubCategoryNameValues
        }
        if (this.selectedParentAsinValues) {
          params['parent_asin'] = this.selectedParentAsinValues
        }
        if (this.selectedSellerCategoryValues) {
          params['seller_category'] = this.selectedSellerCategoryValues
        }
        if (this.selectedSellerCategory2Values) {
          params['seller_category2'] = this.selectedSellerCategory2Values
        }
        if (this.selectedSellerCategory3Values) {
          params['seller_category3'] = this.selectedSellerCategory3Values
        }
        if (this.selectedSellerCategory4Values) {
          params['seller_category4'] = this.selectedSellerCategory4Values
        }
        if (this.selectedSellerCategory5Values) {
          params['seller_category5'] = this.selectedSellerCategory5Values
        }
      }
      return params
    },
    async onClickDownload (action) {
      try {
        await this.downloadCSV({...this.generateParams(this.apiParameters[action]), action})
      } catch (e) {
        console.log(e)
      }
    },
    filterReport: debounce(function () {
      this.getReport()
    }, 1000),
    async getReport () {
      const actions = [
        'firstOrderAsin',
        'firstOrderMonth',
        'monthlyOrder',
        'cohortAnalysis',
        'salesByTitle',
        'salesByAsin',
        'salesByParentAsin',
        'salesByBrand',
        'salesBySubCategoryName',
        'salesBySellerCategory',
        'salesBySellerCategory2',
        'salesBySellerCategory3',
        'salesBySellerCategory4',
        'salesBySellerCategory5'
      ]

      await Promise.all(actions.map(action => {
        return new Promise((resolve) => {
          try {
            resolve(this.fetchReport({
              ...this.generateParams(this.apiParameters[action]),
              action
            }))
          } catch (e) {
            console.log(e)
          }
        })
      }))
      this.resetCurrentPageFlag = true

      // ヒートマップ用に最大値を探索する
      this.cohortAnalysisMaxSales = -1
      if(this.reportData.cohortAnalysis.length > 0) {
        this.reportData.cohortAnalysis.map((row) => {
          for (const [key, value] of Object.entries(row)) {
            if(key.includes('monthsDifference') && value > this.cohortAnalysisMaxSales) {
              this.cohortAnalysisMaxSales = value
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
$themeColor: #7367F0;  // for vue-slider-component
@import '~vue-slider-component/lib/theme/material.scss';

.page_content--loading .vx-card {
  min-height: 127.875px;
}

.text-nowrap {
  text-wrap: nowrap;
}
</style>

<style>
.holamundo :deep(.vs-popup) {
  width: 400px;
}
div.filter {
    display: flex;
    flex-wrap: wrap;
}
.sales-filter .multiselect__tags,
.sales-filter .multiselect__tags .multiselect__input,
.sales-filter .multiselect__content-wrapper {
  font-size: 13px;
}
</style>
